import { render, staticRenderFns } from "./OfficeStar.vue?vue&type=template&id=f8dddff2&"
import script from "./OfficeStar.vue?vue&type=script&lang=js&"
export * from "./OfficeStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports